import React from 'react';
import { Link } from 'react-router-dom';

const PrestigiousGhosts = ({ cursorVisibility }) => {
  return (
    <Link id={cursorVisibility} className="Prestigious-ghosts link none" to="/">
      <div className="vertically-centered">
        <p>
          Prestigious ghosts. Partisans of a certain future. Its cheap products,
        </p>
        <p>
          the heavy artillery, breaking through the Chinese walls of
          understanding.
        </p>
        <br />
        <p>
          Benefactors of the insane. Fading in the essential voyages of
          full-time spectatorship.
        </p>
        <p>Undertaken by the astonishingly incapable.</p>
        <br />
        <p>
          Attrition of fantasy. Trust in the stories of cuckolded singers,
          disaster photographs,
        </p>
        <p>and the grotesque dramas of the gutteral press.</p>
        <br />
        <p>
          Economy of disavowal. At the cinema, the screens are so big. They make
          me feel stupid.
        </p>
        <br />
        <p>
          Spatial lag: Rephrased. Dragging over caffeinated shadows onto the
          enseamed bed.
        </p>
        <p>Eye bent on vacancy.</p>
        <br />
        <p>
          It-district. Distribution of real or imaginary flowers. Samples the
          spirit with a modest proposal for doing away with it.
        </p>
        <br />
        <p>
          Apostrophe, reaching out to you. Presented with the alternatives of
          love or in-unit washer/dryer.
        </p>
        <br />
        <p>
          Trust the last image. It must be sought in the magical locales of
          fairy tales and Yellow Pages.
        </p>
        <br />
        <p>Little will: your ellipses are my braces.</p>
      </div>
    </Link>
  );
};

export default PrestigiousGhosts;
